// Transactionele e-mails (packages/email). Plain text is leidend; de HTML is dezelfde tekst. De
// taal volgt de ontvanger: eigen keuze van het gezinslid, anders die van het gezin, anders nl
// (golf 3, talen). Placeholders: {product} = productnaam, {origin} = adres van de app.
export const emailNl = {
    /** Onder een knop in de HTML-versie. */
    buttonFallback: 'Werkt de knop niet? Kopieer deze link: {url}',
    verify: {
        subject: 'Bevestig je e-mailadres voor {product}',
        lines: [
            'Welkom! Bevestig je e-mailadres om je gezinsbord te kunnen gebruiken.',
            'Deze link is 24 uur geldig. Heb je geen account aangemaakt? Negeer dan deze mail.',
        ],
        cta: 'E-mailadres bevestigen',
    },
    reset: {
        subject: 'Wachtwoord opnieuw instellen',
        lines: [
            'Je hebt gevraagd om een nieuw wachtwoord.',
            'Deze link is 60 minuten geldig en werkt één keer. Heb je dit niet gevraagd? Negeer dan deze mail; je wachtwoord blijft ongewijzigd.',
        ],
        cta: 'Nieuw wachtwoord kiezen',
    },
    invitation: {
        subject: 'Uitnodiging voor het gezinsbord van {household}',
        lines: [
            'Je bent uitgenodigd om mee te doen met het gezinsbord van {household}.',
            'De uitnodiging is 7 dagen geldig.',
        ],
        cta: 'Uitnodiging accepteren',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} nodigt je uit voor {household}',
        lines: [
            '{inviter} nodigt je uit voor {household} op AMUMIN: het rooster, wie eet mee, reserveren en kosten delen, op je eigen telefoon.',
            'Huisgenoten krijgen dezelfde rechten als {inviter}.',
            'De uitnodiging is 7 dagen geldig.',
        ],
        cta: 'Uitnodiging bekijken',
    },
    circleInvite: {
        subject: '{inviter} nodigt je uit om mee te kijken',
        lines: [
            '{inviter} nodigt je uit om mee te kijken bij het gezinsbord van {household}, als "{label}".',
            '{name} zegt zelf op het bord of dat goed is. Daarna zie je alleen wat {name} goedkeurt.',
            'Dit is geen alarmdienst.',
            'De uitnodiging is 7 dagen geldig.',
        ],
        cta: 'Uitnodiging bekijken',
    },
    existingAccount: {
        subject: 'Je hebt al een {product}-account',
        lines: [
            'Iemand probeerde met dit e-mailadres een nieuw account aan te maken, maar er bestaat er al een.',
            'Was jij dit? Log dan gewoon in. Wachtwoord vergeten? Vraag een nieuw wachtwoord aan via de knop hieronder.',
            'Was jij dit niet? Dan hoef je niets te doen; er is niets gewijzigd.',
        ],
        cta: 'Inloggen',
    },
    newLogin: {
        subject: 'Nieuwe login op je {product}-account',
        lines: [
            'Op {when} is er ingelogd vanuit een browser die we nog niet kenden.',
            'Was jij dit? Dan hoef je niets te doen.',
            'Was jij dit niet? Wijzig dan je wachtwoord en log overal uit via {origin}/instellingen/beveiliging.',
        ],
    },
    devicePaired: {
        subject: 'Tablet "{device}" gekoppeld aan {room}',
        lines: [
            'Op {when} is de tablet "{device}" gekoppeld aan de kamer {room} van jullie gezinsbord.',
            'Heb jij of je partner dit gedaan? Dan hoef je niets te doen.',
            'Herken je dit niet? Trek de koppeling dan in via {origin}/apparaten en wijzig je wachtwoord.',
        ],
    },
    loginCode: {
        subject: '{code} is je code voor {product}',
        code: 'Je code: {code}',
        whyNetwork: 'Je wilt een netwerk als vertrouwd toevoegen. Voer deze code in om dat te bevestigen.',
        whyLogin: 'Er is ingelogd met je wachtwoord. Voer deze code in dezelfde browser in; na bevestiging vertrouwen we die browser 30 dagen (tot {until}).',
        details: 'Browser: {browser} · netwerk: {network} · {when}.',
        unknown: 'onbekend',
        validity: 'De code is 10 minuten geldig.',
        warning: 'Wij vragen nooit om deze code per telefoon, chat of e-mail; voer hem alleen in op {host}.',
        cta: 'Dit was ik niet',
    },
    trustedBrowser: {
        subject: 'Nieuwe vertrouwde browser voor {product}',
        someBrowser: 'Een browser',
        lines: [
            '{browser} is nu een vertrouwde browser, geldig tot {until}.',
            'In die browser vragen we tot dan geen e-mailcode meer; je wachtwoord blijft altijd nodig.',
            'Was jij dit niet? Wijzig dan je wachtwoord en vergeet alle browsers via {origin}/instellingen/beveiliging.',
        ],
    },
    trustedNetwork: {
        subject: '{label} {verb} door {name}',
        verbs: {
            added: 'toegevoegd als vertrouwd netwerk (nog niet bevestigd)',
            confirmed: 'bevestigd als vertrouwd netwerk',
            updated: 'gewijzigd',
            disabled: 'uitgeschakeld als vertrouwd netwerk',
            removed: 'verwijderd als vertrouwd netwerk',
        },
        household: 'Dit geldt voor alle ouders van het huishouden: vanaf dit netwerk vragen we na het wachtwoord geen e-mailcode.',
        identity: 'Dit geldt alleen voor {name}.',
        check: 'Klopt dit niet? Bekijk de vertrouwde netwerken via {origin}/instellingen/beveiliging.',
    },
    lockout: {
        subject: 'Inloggen met e-mailcode tijdelijk geblokkeerd',
        lines: [
            'Er zijn te veel inlogcodes aangevraagd of fout ingevoerd. Tot {until} sturen we geen nieuwe codes.',
            'Was jij dit niet? Dan kent iemand anders mogelijk je wachtwoord: wijzig het via "Wachtwoord vergeten".',
        ],
    },
    wanChanged: {
        subject: 'Het internetadres van je server is gewijzigd',
        lines: [
            'Op {when} kreeg de server een nieuw internetadres van je provider.',
            'Het vertrouwde netwerk "Thuis (WAN)" volgt dit automatisch. Verwachtte je dit niet? Controleer je router en de vertrouwde netwerken.',
        ],
    },
    recoveryReuse: {
        subject: 'Let op: tablet "{device}" gemarkeerd als verdacht',
        lines: [
            'De hersteltoken van de tablet "{device}" is een tweede keer gebruikt.',
            'De tablet is tijdelijk gemarkeerd als verdacht. Controleer in de app onder Apparaten of alles klopt en bevestig of trek de koppeling in.',
        ],
    },
    familyLink: {
        subject: '{name} wil jullie gezinsbord koppelen',
        lines: [
            '{name} wil een paar dingen met jullie delen, zoals verjaardagen en wensenlijstjes.',
            'Jullie kiezen daarna zelf wat jullie terug delen. De uitnodiging is 7 dagen geldig.',
            'Nog geen {product}? Maak dan eerst een gratis account aan met dit e-mailadres.',
        ],
        cta: 'Koppeling bekijken',
    },
    // 0065: aanmelden, proefmaand en abonnement (packages/email/src/billing.ts). {date} = laatste
    // gratis dag of einddatum (huistijd, voluit); {price} = bedrag met "per maand"; {code} = 6 cijfers.
    billing: {
        signupCode: {
            subject: '{code} is je code om je aanmelding af te ronden',
            lines: [
                'Welkom bij {product}! Je code is {code}.',
                'Typ de code op het scherm waar je je aanmeldt, of gebruik de knop hieronder in dezelfde browser.',
                'De code is 10 minuten geldig en de knop 24 uur. Heb je je niet aangemeld? Negeer dan deze mail; er gebeurt niets.',
                'Wij vragen nooit om deze code per telefoon, chat of e-mail; voer hem alleen in op {host}.',
            ],
            cta: 'Aanmelding afronden',
        },
        priceLine: 'Daarna kost het {price}. Je kunt altijd opzeggen.',
        priceUnknown: 'Wat het daarna kost, laten we je ruim vóór het einde weten. Je kunt altijd opzeggen.',
        perMonth: '{amount} per maand',
        trialWelcome: {
            subject: 'Welkom! Je proefmaand loopt tot en met {date}',
            lines: [
                'Fijn dat jullie {product} gebruiken. De eerste maand is gratis, tot en met {date}.',
                'Je hoeft nu niets te betalen of in te vullen. Een week voor het einde sturen we een herinnering.',
            ],
            cta: 'Naar de app',
        },
        trialReminder7d: {
            subject: 'Nog een week gratis: je proefmaand loopt tot en met {date}',
            lines: [
                'Je proefmaand van {product} loopt nog tot en met {date}.',
                'Wil je daarna doorgaan? Voeg je betaalgegevens toe bij Instellingen › Abonnement.',
                'Doe je niets, dan kun je daarna alles nog bekijken, maar niets meer toevoegen of wijzigen. We wissen niets.',
            ],
            cta: 'Abonnement bekijken',
        },
        trialReminder1d: {
            subject: 'Vandaag is je laatste gratis dag',
            lines: [
                'Vandaag ({date}) is de laatste dag van je gratis maand van {product}.',
                'Wil je zonder onderbreking doorgaan? Voeg vandaag je betaalgegevens toe bij Instellingen › Abonnement.',
                'Doe je niets, dan staat het bord morgen op alleen kijken. Je gegevens blijven bewaard.',
            ],
            cta: 'Betaalgegevens toevoegen',
        },
        trialExpired: {
            subject: 'Je proefmaand is voorbij',
            lines: [
                'Je gratis maand van {product} is voorbij. Alles staat er nog: je kunt de agenda en de rest bekijken, ook op het bord.',
                'Toevoegen en wijzigen kan weer zodra je je betaalgegevens hebt toegevoegd.',
                'Wil je stoppen? Dan hoef je niets te doen. We wissen je gegevens nooit vanzelf; verwijderen kan bij Instellingen › Jouw gegevens.',
            ],
            cta: 'Abonnement bekijken',
        },
        expiredFollowup: {
            subject: 'Willen jullie verder met {product}?',
            lines: [
                'Jullie proefmaand is een maand geleden afgelopen. Het bord staat nog op alleen kijken.',
                'Doorgaan kan altijd: voeg je betaalgegevens toe bij Instellingen › Abonnement.',
                'Liever stoppen? Zeg dan op of verwijder het gezinsbord bij Instellingen › Jouw gegevens. Hierover sturen we geen mail meer.',
            ],
            cta: 'Abonnement bekijken',
        },
        cancelled: {
            subject: 'Je abonnement is opgezegd',
            lines: [
                'Je hebt je abonnement op {product} opgezegd. Tot en met {date} werkt alles zoals nu.',
                'Daarna kun je alles nog bekijken, maar niets meer wijzigen. We wissen niets vanzelf.',
                'Toch doorgaan? Dat kan tot en met {date} bij Instellingen › Abonnement.',
            ],
            cta: 'Abonnement bekijken',
        },
    },
};
//# sourceMappingURL=email.nl.js.map